// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AppControllerGetFrontendConfigData, AppControllerGetFrontendConfigResponses, AppControllerGetVersionData, AppControllerGetVersionResponses, AttributeProviderControllerCreateData, AttributeProviderControllerCreateResponses, AttributeProviderControllerDeleteData, AttributeProviderControllerDeleteErrors, AttributeProviderControllerDeleteResponses, AttributeProviderControllerGetAllData, AttributeProviderControllerGetAllResponses, AttributeProviderControllerGetByIdData, AttributeProviderControllerGetByIdErrors, AttributeProviderControllerGetByIdResponses, AttributeProviderControllerUpdateData, AttributeProviderControllerUpdateErrors, AttributeProviderControllerUpdateResponses, AuditLogControllerGetAuditLogsData, AuditLogControllerGetAuditLogsResponses, AuthControllerGetOAuth2TokenData, AuthControllerGetOAuth2TokenErrors, AuthControllerGetOAuth2TokenResponses, CacheControllerClearAllCachesData, CacheControllerClearAllCachesResponses, CacheControllerClearStatusListCacheData, CacheControllerClearStatusListCacheResponses, CacheControllerClearTrustListCacheData, CacheControllerClearTrustListCacheResponses, CacheControllerGetStatsData, CacheControllerGetStatsResponses, ClientControllerCreateClientData, ClientControllerCreateClientErrors, ClientControllerCreateClientResponses, ClientControllerDeleteClientData, ClientControllerDeleteClientErrors, ClientControllerDeleteClientResponses, ClientControllerGetClientData, ClientControllerGetClientErrors, ClientControllerGetClientResponses, ClientControllerGetClientsData, ClientControllerGetClientsResponses, ClientControllerRotateClientSecretData, ClientControllerRotateClientSecretErrors, ClientControllerRotateClientSecretResponses, ClientControllerUpdateClientData, ClientControllerUpdateClientErrors, ClientControllerUpdateClientResponses, ConfigPortabilityControllerAcknowledgeInterruptionData, ConfigPortabilityControllerAcknowledgeInterruptionResponses, ConfigPortabilityControllerDetachData, ConfigPortabilityControllerDetachResponses, ConfigPortabilityControllerExportData, ConfigPortabilityControllerExportDocumentData, ConfigPortabilityControllerExportDocumentErrors, ConfigPortabilityControllerExportDocumentResponses, ConfigPortabilityControllerExportResponses, ConfigPortabilityControllerImportArchiveData, ConfigPortabilityControllerImportArchiveResponses, ConfigPortabilityControllerImportData, ConfigPortabilityControllerImportResponses, ConfigPortabilityControllerOperationData, ConfigPortabilityControllerOperationResponses, ConfigPortabilityControllerOperationsData, ConfigPortabilityControllerOperationsResponses, ConfigPortabilityControllerPlanArchiveData, ConfigPortabilityControllerPlanArchiveResponses, ConfigPortabilityControllerPlanData, ConfigPortabilityControllerPlanReattachData, ConfigPortabilityControllerPlanReattachResponses, ConfigPortabilityControllerPlanResponses, ConfigPortabilityControllerReattachData, ConfigPortabilityControllerReattachResponses, ConfigPortabilityControllerResourcesData, ConfigPortabilityControllerResourcesOfKindData, ConfigPortabilityControllerResourcesOfKindErrors, ConfigPortabilityControllerResourcesOfKindResponses, ConfigPortabilityControllerResourcesResponses, ConfigPortabilityControllerUpgradeData, ConfigPortabilityControllerUpgradeResponses, CredentialConfigControllerDeleteIssuanceConfigurationData, CredentialConfigControllerDeleteIssuanceConfigurationResponses, CredentialConfigControllerGetConfigByIdData, CredentialConfigControllerGetConfigByIdResponses, CredentialConfigControllerGetConfigsData, CredentialConfigControllerGetConfigsResponses, CredentialConfigControllerStoreCredentialConfigurationData, CredentialConfigControllerStoreCredentialConfigurationResponses, CredentialConfigControllerUpdateCredentialConfigurationData, CredentialConfigControllerUpdateCredentialConfigurationResponses, CredentialOfferControllerGetOfferData, CredentialOfferControllerGetOfferResponses, DefaultAccessKeyChainControllerGetData, DefaultAccessKeyChainControllerGetResponses, DefaultAccessKeyChainControllerSetData, DefaultAccessKeyChainControllerSetErrors, DefaultAccessKeyChainControllerSetResponses, DeferredControllerCompleteDeferredData, DeferredControllerCompleteDeferredErrors, DeferredControllerCompleteDeferredResponses, DeferredControllerFailDeferredData, DeferredControllerFailDeferredErrors, DeferredControllerFailDeferredResponses, FederationTrustAnchorControllerCreateData, FederationTrustAnchorControllerCreateErrors, FederationTrustAnchorControllerCreateResponses, FederationTrustAnchorControllerDeleteData, FederationTrustAnchorControllerDeleteErrors, FederationTrustAnchorControllerDeleteResponses, FederationTrustAnchorControllerGetAllData, FederationTrustAnchorControllerGetAllResponses, FederationTrustAnchorControllerGetByIdData, FederationTrustAnchorControllerGetByIdErrors, FederationTrustAnchorControllerGetByIdResponses, FederationTrustAnchorControllerUpdateData, FederationTrustAnchorControllerUpdateErrors, FederationTrustAnchorControllerUpdateResponses, IssuanceConfigControllerGetIssuanceConfigurationsData, IssuanceConfigControllerGetIssuanceConfigurationsResponses, IssuanceConfigControllerReissueRegistrationCertificateData, IssuanceConfigControllerReissueRegistrationCertificateErrors, IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerStoreIssuanceConfigurationData, IssuanceConfigControllerStoreIssuanceConfigurationResponses, KeyChainControllerCreateCsrData, KeyChainControllerCreateCsrErrors, KeyChainControllerCreateCsrResponses, KeyChainControllerCreateData, KeyChainControllerCreateResponses, KeyChainControllerDeleteData, KeyChainControllerDeleteErrors, KeyChainControllerDeleteResponses, KeyChainControllerDeleteTenantKmsConfigData, KeyChainControllerDeleteTenantKmsConfigErrors, KeyChainControllerDeleteTenantKmsConfigResponses, KeyChainControllerExportData, KeyChainControllerExportErrors, KeyChainControllerExportResponses, KeyChainControllerGetAllData, KeyChainControllerGetAllResponses, KeyChainControllerGetByIdData, KeyChainControllerGetByIdErrors, KeyChainControllerGetByIdResponses, KeyChainControllerGetProvidersData, KeyChainControllerGetProvidersHealthData, KeyChainControllerGetProvidersHealthResponses, KeyChainControllerGetProvidersResponses, KeyChainControllerGetTenantKmsConfigData, KeyChainControllerGetTenantKmsConfigErrors, KeyChainControllerGetTenantKmsConfigResponses, KeyChainControllerImportData, KeyChainControllerImportErrors, KeyChainControllerImportResponses, KeyChainControllerRotateData, KeyChainControllerRotateErrors, KeyChainControllerRotateResponses, KeyChainControllerUpdateData, KeyChainControllerUpdateErrors, KeyChainControllerUpdateResponses, KeyChainControllerUpdateTenantKmsConfigData, KeyChainControllerUpdateTenantKmsConfigErrors, KeyChainControllerUpdateTenantKmsConfigResponses, PresentationManagementControllerConfigurationData, PresentationManagementControllerConfigurationResponses, PresentationManagementControllerDeleteConfigurationData, PresentationManagementControllerDeleteConfigurationResponses, PresentationManagementControllerGetConfigurationData, PresentationManagementControllerGetConfigurationResponses, PresentationManagementControllerListSchemaMetadataCatalogData, PresentationManagementControllerListSchemaMetadataCatalogResponses, PresentationManagementControllerReissueRegistrationCertificateData, PresentationManagementControllerReissueRegistrationCertificateErrors, PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerResolveIssuerMetadataData, PresentationManagementControllerResolveIssuerMetadataErrors, PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveSchemaMetadataData, PresentationManagementControllerResolveSchemaMetadataErrors, PresentationManagementControllerResolveSchemaMetadataJwtData, PresentationManagementControllerResolveSchemaMetadataJwtErrors, PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerStorePresentationConfigData, PresentationManagementControllerStorePresentationConfigErrors, PresentationManagementControllerStorePresentationConfigResponses, PresentationManagementControllerUpdateConfigurationData, PresentationManagementControllerUpdateConfigurationErrors, PresentationManagementControllerUpdateConfigurationResponses, RegistrarControllerCreateAccessCertificateData, RegistrarControllerCreateAccessCertificateErrors, RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateAccessKeyChainData, RegistrarControllerCreateAccessKeyChainErrors, RegistrarControllerCreateAccessKeyChainResponses, RegistrarControllerCreateConfigData, RegistrarControllerCreateConfigErrors, RegistrarControllerCreateConfigResponses, RegistrarControllerDeleteConfigData, RegistrarControllerDeleteConfigResponses, RegistrarControllerGetConfigData, RegistrarControllerGetConfigErrors, RegistrarControllerGetConfigResponses, RegistrarControllerUpdateConfigData, RegistrarControllerUpdateConfigErrors, RegistrarControllerUpdateConfigResponses, SchemaMetadataControllerDeprecateVersionData, SchemaMetadataControllerDeprecateVersionResponses, SchemaMetadataControllerFindAllData, SchemaMetadataControllerFindAllResponses, SchemaMetadataControllerFindOneData, SchemaMetadataControllerFindOneResponses, SchemaMetadataControllerGetJwtData, SchemaMetadataControllerGetJwtResponses, SchemaMetadataControllerGetLatestData, SchemaMetadataControllerGetLatestResponses, SchemaMetadataControllerGetMineData, SchemaMetadataControllerGetMineResponses, SchemaMetadataControllerGetSchemaData, SchemaMetadataControllerGetSchemaResponses, SchemaMetadataControllerGetVersionsData, SchemaMetadataControllerGetVersionsResponses, SchemaMetadataControllerGetVocabulariesData, SchemaMetadataControllerGetVocabulariesResponses, SchemaMetadataControllerPublishSchemaMetadataData, SchemaMetadataControllerPublishSchemaMetadataErrors, SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataVersionData, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerRemoveData, SchemaMetadataControllerRemoveResponses, SchemaMetadataControllerUpdateData, SchemaMetadataControllerUpdateResponses, SessionConfigControllerGetConfigData, SessionConfigControllerGetConfigResponses, SessionConfigControllerResetConfigData, SessionConfigControllerResetConfigResponses, SessionConfigControllerUpdateConfigData, SessionConfigControllerUpdateConfigResponses, SessionControllerCancelData, SessionControllerCancelErrors, SessionControllerCancelResponses, SessionControllerDeleteSessionData, SessionControllerDeleteSessionResponses, SessionControllerGetAllSessionsData, SessionControllerGetAllSessionsResponses, SessionControllerGetCredentialStatusData, SessionControllerGetCredentialStatusErrors, SessionControllerGetCredentialStatusResponses, SessionControllerGetSessionData, SessionControllerGetSessionLogsData, SessionControllerGetSessionLogsResponses, SessionControllerGetSessionResponses, SessionControllerGetSessionStatsData, SessionControllerGetSessionStatsResponses, SessionControllerRevokeAllData, SessionControllerRevokeAllErrors, SessionControllerRevokeAllResponses, SessionEventsControllerSubscribeToSessionEventsData, SessionEventsControllerSubscribeToSessionEventsErrors, SessionEventsControllerSubscribeToSessionEventsResponse, SessionEventsControllerSubscribeToSessionEventsResponses, StatusListConfigControllerGetConfigData, StatusListConfigControllerGetConfigResponses, StatusListConfigControllerResetConfigData, StatusListConfigControllerResetConfigResponses, StatusListConfigControllerUpdateConfigData, StatusListConfigControllerUpdateConfigResponses, StatusListManagementControllerCreateListData, StatusListManagementControllerCreateListResponses, StatusListManagementControllerDeleteListData, StatusListManagementControllerDeleteListResponses, StatusListManagementControllerGetListData, StatusListManagementControllerGetListResponses, StatusListManagementControllerGetListsData, StatusListManagementControllerGetListsResponses, StatusListManagementControllerUpdateListData, StatusListManagementControllerUpdateListResponses, StorageControllerUploadData, StorageControllerUploadResponses, TenantControllerDeleteTenantData, TenantControllerDeleteTenantResponses, TenantControllerGetTenantData, TenantControllerGetTenantResponses, TenantControllerGetTenantsData, TenantControllerGetTenantsResponses, TenantControllerInitTenantData, TenantControllerInitTenantErrors, TenantControllerInitTenantResponses, TenantControllerUpdateTenantData, TenantControllerUpdateTenantResponses, TrustListControllerCreateTrustListData, TrustListControllerCreateTrustListResponses, TrustListControllerDeleteTrustListData, TrustListControllerDeleteTrustListErrors, TrustListControllerDeleteTrustListResponses, TrustListControllerExportTrustListData, TrustListControllerExportTrustListResponses, TrustListControllerGetAllTrustListsData, TrustListControllerGetAllTrustListsResponses, TrustListControllerGetTrustListData, TrustListControllerGetTrustListResponses, TrustListControllerGetTrustListVersionData, TrustListControllerGetTrustListVersionResponses, TrustListControllerGetTrustListVersionsData, TrustListControllerGetTrustListVersionsResponses, TrustListControllerUpdateTrustListData, TrustListControllerUpdateTrustListResponses, UserControllerCreateUserData, UserControllerCreateUserErrors, UserControllerCreateUserResponses, UserControllerDeleteUserData, UserControllerDeleteUserErrors, UserControllerDeleteUserResponses, UserControllerGetUserData, UserControllerGetUserResponses, UserControllerGetUsersData, UserControllerGetUsersResponses, UserControllerUpdateUserData, UserControllerUpdateUserErrors, UserControllerUpdateUserResponses, VerifierOfferControllerGetOfferData, VerifierOfferControllerGetOfferResponses, WebhookEndpointControllerCreateData, WebhookEndpointControllerCreateResponses, WebhookEndpointControllerDeleteData, WebhookEndpointControllerDeleteErrors, WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerGetAllData, WebhookEndpointControllerGetAllResponses, WebhookEndpointControllerGetByIdData, WebhookEndpointControllerGetByIdErrors, WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerUpdateData, WebhookEndpointControllerUpdateErrors, WebhookEndpointControllerUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get service version
 */
export const appControllerGetVersion = <ThrowOnError extends boolean = true>(options?: Options<AppControllerGetVersionData, ThrowOnError>): RequestResult<AppControllerGetVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerGetVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/version',
    ...options
});

/**
 * Get frontend runtime configuration
 */
export const appControllerGetFrontendConfig = <ThrowOnError extends boolean = true>(options?: Options<AppControllerGetFrontendConfigData, ThrowOnError>): RequestResult<AppControllerGetFrontendConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerGetFrontendConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/frontend-config',
    ...options
});

/**
 * OAuth2 Token endpoint - supports client credentials flow only
 * Accepts client credentials either in Authorization header (Basic auth) or request body
 */
export const authControllerGetOAuth2Token = <ThrowOnError extends boolean = true>(options: Options<AuthControllerGetOAuth2TokenData, ThrowOnError>): RequestResult<AuthControllerGetOAuth2TokenResponses, AuthControllerGetOAuth2TokenErrors, ThrowOnError> => (options.client ?? client).post<AuthControllerGetOAuth2TokenResponses, AuthControllerGetOAuth2TokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/oauth2/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Get all tenants
 */
export const tenantControllerGetTenants = <ThrowOnError extends boolean = true>(options?: Options<TenantControllerGetTenantsData, ThrowOnError>): RequestResult<TenantControllerGetTenantsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantControllerGetTenantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant',
    ...options
});

/**
 * Initialize a tenant
 */
export const tenantControllerInitTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerInitTenantData, ThrowOnError>): RequestResult<TenantControllerInitTenantResponses, TenantControllerInitTenantErrors, ThrowOnError> => (options.client ?? client).post<TenantControllerInitTenantResponses, TenantControllerInitTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a tenant by ID
 */
export const tenantControllerDeleteTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerDeleteTenantData, ThrowOnError>): RequestResult<TenantControllerDeleteTenantResponses, unknown, ThrowOnError> => (options.client ?? client).delete<TenantControllerDeleteTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options
});

/**
 * Get a tenant by ID
 */
export const tenantControllerGetTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerGetTenantData, ThrowOnError>): RequestResult<TenantControllerGetTenantResponses, unknown, ThrowOnError> => (options.client ?? client).get<TenantControllerGetTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options
});

/**
 * Update a tenant by ID
 */
export const tenantControllerUpdateTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerUpdateTenantData, ThrowOnError>): RequestResult<TenantControllerUpdateTenantResponses, unknown, ThrowOnError> => (options.client ?? client).patch<TenantControllerUpdateTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the default access key chain
 *
 * Returns the tenant's defaultAccessKeyChainId and the access key chain that presentation requests of configurations without accessKeyChainId and the signed issuer metadata use.
 */
export const defaultAccessKeyChainControllerGet = <ThrowOnError extends boolean = true>(options?: Options<DefaultAccessKeyChainControllerGetData, ThrowOnError>): RequestResult<DefaultAccessKeyChainControllerGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DefaultAccessKeyChainControllerGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/access/default',
    ...options
});

/**
 * Set the default access key chain
 *
 * Names the access key chain used where no configuration names one, or removes the setting with null so EUDIPLO picks one by rule. A presentation configuration's accessKeyChainId still takes precedence. While a key chain is the default, deleting it is refused.
 */
export const defaultAccessKeyChainControllerSet = <ThrowOnError extends boolean = true>(options: Options<DefaultAccessKeyChainControllerSetData, ThrowOnError>): RequestResult<DefaultAccessKeyChainControllerSetResponses, DefaultAccessKeyChainControllerSetErrors, ThrowOnError> => (options.client ?? client).put<DefaultAccessKeyChainControllerSetResponses, DefaultAccessKeyChainControllerSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/access/default',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recent audit log entries for the current tenant
 */
export const auditLogControllerGetAuditLogs = <ThrowOnError extends boolean = true>(options?: Options<AuditLogControllerGetAuditLogsData, ThrowOnError>): RequestResult<AuditLogControllerGetAuditLogsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuditLogControllerGetAuditLogsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/audit-logs',
    ...options
});

/**
 * Get all clients for the current tenant
 */
export const clientControllerGetClients = <ThrowOnError extends boolean = true>(options?: Options<ClientControllerGetClientsData, ThrowOnError>): RequestResult<ClientControllerGetClientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ClientControllerGetClientsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client',
    ...options
});

/**
 * Create a new client
 */
export const clientControllerCreateClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerCreateClientData, ThrowOnError>): RequestResult<ClientControllerCreateClientResponses, ClientControllerCreateClientErrors, ThrowOnError> => (options.client ?? client).post<ClientControllerCreateClientResponses, ClientControllerCreateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a client
 */
export const clientControllerDeleteClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerDeleteClientData, ThrowOnError>): RequestResult<ClientControllerDeleteClientResponses, ClientControllerDeleteClientErrors, ThrowOnError> => (options.client ?? client).delete<ClientControllerDeleteClientResponses, ClientControllerDeleteClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options
});

/**
 * Get a client by its id
 */
export const clientControllerGetClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerGetClientData, ThrowOnError>): RequestResult<ClientControllerGetClientResponses, ClientControllerGetClientErrors, ThrowOnError> => (options.client ?? client).get<ClientControllerGetClientResponses, ClientControllerGetClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options
});

/**
 * Update a client by its id
 */
export const clientControllerUpdateClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerUpdateClientData, ThrowOnError>): RequestResult<ClientControllerUpdateClientResponses, ClientControllerUpdateClientErrors, ThrowOnError> => (options.client ?? client).patch<ClientControllerUpdateClientResponses, ClientControllerUpdateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate (regenerate) a client's secret.
 * Returns the new secret for one-time display - save it immediately!
 *
 * Users with `tenants:manage` role can rotate secrets for any client.
 * Users with `clients:manage` role can only rotate secrets for clients in
 * their tenant whose roles they hold or may grant.
 *
 * With the built-in authorization server, tokens issued with the old secret
 * are rejected at once (HTTP 401).
 */
export const clientControllerRotateClientSecret = <ThrowOnError extends boolean = true>(options: Options<ClientControllerRotateClientSecretData, ThrowOnError>): RequestResult<ClientControllerRotateClientSecretResponses, ClientControllerRotateClientSecretErrors, ThrowOnError> => (options.client ?? client).post<ClientControllerRotateClientSecretResponses, ClientControllerRotateClientSecretErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}/rotate-secret',
    ...options
});

/**
 * Delete registrar configuration
 */
export const registrarControllerDeleteConfig = <ThrowOnError extends boolean = true>(options?: Options<RegistrarControllerDeleteConfigData, ThrowOnError>): RequestResult<RegistrarControllerDeleteConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RegistrarControllerDeleteConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options
});

/**
 * Get registrar configuration
 */
export const registrarControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<RegistrarControllerGetConfigData, ThrowOnError>): RequestResult<RegistrarControllerGetConfigResponses, RegistrarControllerGetConfigErrors, ThrowOnError> => (options?.client ?? client).get<RegistrarControllerGetConfigResponses, RegistrarControllerGetConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options
});

/**
 * Update registrar configuration
 */
export const registrarControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerUpdateConfigData, ThrowOnError>): RequestResult<RegistrarControllerUpdateConfigResponses, RegistrarControllerUpdateConfigErrors, ThrowOnError> => (options.client ?? client).patch<RegistrarControllerUpdateConfigResponses, RegistrarControllerUpdateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or replace registrar configuration
 */
export const registrarControllerCreateConfig = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerCreateConfigData, ThrowOnError>): RequestResult<RegistrarControllerCreateConfigResponses, RegistrarControllerCreateConfigErrors, ThrowOnError> => (options.client ?? client).post<RegistrarControllerCreateConfigResponses, RegistrarControllerCreateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an access certificate for a key
 *
 * Creates an access certificate at the registrar for the specified key. Registers the tenant as relying party at the registrar if it is not yet. The certificate is automatically stored in EUDIPLO. When the certificate request fails, a certificate the registrar already issued for the key in this request (for example after a lost response) is stored instead; a certificate EUDIPLO cannot store is revoked at the registrar.
 */
export const registrarControllerCreateAccessCertificate = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerCreateAccessCertificateData, ThrowOnError>): RequestResult<RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateAccessCertificateErrors, ThrowOnError> => (options.client ?? client).post<RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateAccessCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/access-certificate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an access key chain enrolled at the registrar
 *
 * Creates a standalone access key chain and requests its access certificate at the registrar in one request. Registers the tenant as relying party at the registrar if it is not yet. When the registrar refuses or the certificate cannot be stored, the key chain is deleted again, so no self-signed access key chain is left behind.
 */
export const registrarControllerCreateAccessKeyChain = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerCreateAccessKeyChainData, ThrowOnError>): RequestResult<RegistrarControllerCreateAccessKeyChainResponses, RegistrarControllerCreateAccessKeyChainErrors, ThrowOnError> => (options.client ?? client).post<RegistrarControllerCreateAccessKeyChainResponses, RegistrarControllerCreateAccessKeyChainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/access-key-chain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all managed users for the current tenant
 */
export const userControllerGetUsers = <ThrowOnError extends boolean = true>(options?: Options<UserControllerGetUsersData, ThrowOnError>): RequestResult<UserControllerGetUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options
});

/**
 * Create a new managed user
 */
export const userControllerCreateUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerCreateUserData, ThrowOnError>): RequestResult<UserControllerCreateUserResponses, UserControllerCreateUserErrors, ThrowOnError> => (options.client ?? client).post<UserControllerCreateUserResponses, UserControllerCreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a managed user
 */
export const userControllerDeleteUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerDeleteUserData, ThrowOnError>): RequestResult<UserControllerDeleteUserResponses, UserControllerDeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<UserControllerDeleteUserResponses, UserControllerDeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Get a managed user by id
 */
export const userControllerGetUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerGetUserData, ThrowOnError>): RequestResult<UserControllerGetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UserControllerGetUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Update a managed user
 */
export const userControllerUpdateUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerUpdateUserData, ThrowOnError>): RequestResult<UserControllerUpdateUserResponses, UserControllerUpdateUserErrors, ThrowOnError> => (options.client ?? client).patch<UserControllerUpdateUserResponses, UserControllerUpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get available KMS providers
 */
export const keyChainControllerGetProviders = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetProvidersData, ThrowOnError>): RequestResult<KeyChainControllerGetProvidersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetProvidersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers',
    ...options
});

/**
 * Health probe for every KMS provider
 */
export const keyChainControllerGetProvidersHealth = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetProvidersHealthData, ThrowOnError>): RequestResult<KeyChainControllerGetProvidersHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetProvidersHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/health',
    ...options
});

/**
 * Delete tenant KMS provider configuration
 *
 * Removes <CONFIG_FOLDER>/<tenantId>/kms.json and falls back to global KMS config. Requires the `tenant:admin` or `tenants:manage` role.
 */
export const keyChainControllerDeleteTenantKmsConfig = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerDeleteTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerDeleteTenantKmsConfigResponses, KeyChainControllerDeleteTenantKmsConfigErrors, ThrowOnError> => (options?.client ?? client).delete<KeyChainControllerDeleteTenantKmsConfigResponses, KeyChainControllerDeleteTenantKmsConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options
});

/**
 * Get tenant KMS provider configuration
 *
 * Returns tenant-specific KMS config (if present) and the effective merged runtime config. Credentials are returned as `<redacted>`; `${ENV_VAR}` placeholders of the tenant file are returned as stored. Requires the `tenant:admin` or `tenants:manage` role.
 */
export const keyChainControllerGetTenantKmsConfig = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerGetTenantKmsConfigResponses, KeyChainControllerGetTenantKmsConfigErrors, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetTenantKmsConfigResponses, KeyChainControllerGetTenantKmsConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options
});

/**
 * Create or replace tenant KMS provider configuration
 *
 * A credential sent as `<redacted>` keeps the stored value of the provider with the same `id` and `type`; send a new value or a `${ENV_VAR}` placeholder to replace it. `<redacted>` for a credential that is not stored is rejected with 400. The response is redacted like GET. Requires the `tenant:admin` or `tenants:manage` role.
 */
export const keyChainControllerUpdateTenantKmsConfig = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerUpdateTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerUpdateTenantKmsConfigResponses, KeyChainControllerUpdateTenantKmsConfigErrors, ThrowOnError> => (options.client ?? client).put<KeyChainControllerUpdateTenantKmsConfigResponses, KeyChainControllerUpdateTenantKmsConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List user-manageable signing key chains for the tenant
 */
export const keyChainControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetAllData, ThrowOnError>): RequestResult<KeyChainControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain',
    ...options
});

/**
 * Create a new key chain
 */
export const keyChainControllerCreate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerCreateData, ThrowOnError>): RequestResult<KeyChainControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<KeyChainControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a key chain
 *
 * Refused while the tenant's key chain defaults, the issuance configuration, a credential config, a presentation config, a status list or a trust list of the tenant names the key chain. A configuration that names no key chain and uses the tenant's default one does not count; a trust list stores the key chain that signs it, also one picked by default.
 */
export const keyChainControllerDelete = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerDeleteData, ThrowOnError>): RequestResult<KeyChainControllerDeleteResponses, KeyChainControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<KeyChainControllerDeleteResponses, KeyChainControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options
});

/**
 * Get a key chain by ID
 */
export const keyChainControllerGetById = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerGetByIdData, ThrowOnError>): RequestResult<KeyChainControllerGetByIdResponses, KeyChainControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<KeyChainControllerGetByIdResponses, KeyChainControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options
});

/**
 * Update key chain metadata and rotation policy
 */
export const keyChainControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerUpdateData, ThrowOnError>): RequestResult<KeyChainControllerUpdateResponses, KeyChainControllerUpdateErrors, ThrowOnError> => (options.client ?? client).put<KeyChainControllerUpdateResponses, KeyChainControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a key chain in config-import format
 *
 * Returns the key chain in the same format used by config import JSON files. For keys held in the database (`db` provider) the response includes the private key; for external KMS providers only the public key is returned because the private key never leaves the KMS. Requires the `tenant:admin` or `tenants:manage` role.
 */
export const keyChainControllerExport = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerExportData, ThrowOnError>): RequestResult<KeyChainControllerExportResponses, KeyChainControllerExportErrors, ThrowOnError> => (options.client ?? client).get<KeyChainControllerExportResponses, KeyChainControllerExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}/export',
    ...options
});

/**
 * Create a certificate signing request for the active key
 *
 * Returns a PKCS#10 certificate signing request (CSR) for the active key of the key chain, signed by that key in its KMS. Hand it to an external CA and store the issued certificate with `PUT /api/key-chain/{id}` in `activeCertificate`. The key does not leave EUDIPLO. Each call signs a new request; a rotation replaces the key, and a CSR from before it no longer fits.
 */
export const keyChainControllerCreateCsr = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerCreateCsrData, ThrowOnError>): RequestResult<KeyChainControllerCreateCsrResponses, KeyChainControllerCreateCsrErrors, ThrowOnError> => (options.client ?? client).get<KeyChainControllerCreateCsrResponses, KeyChainControllerCreateCsrErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}/csr',
    ...options
});

/**
 * Import an existing key chain
 */
export const keyChainControllerImport = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerImportData, ThrowOnError>): RequestResult<KeyChainControllerImportResponses, KeyChainControllerImportErrors, ThrowOnError> => (options.client ?? client).post<KeyChainControllerImportResponses, KeyChainControllerImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the signing key in a key chain
 */
export const keyChainControllerRotate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerRotateData, ThrowOnError>): RequestResult<KeyChainControllerRotateResponses, KeyChainControllerRotateErrors, ThrowOnError> => (options.client ?? client).post<KeyChainControllerRotateResponses, KeyChainControllerRotateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}/rotate',
    ...options
});

/**
 * List all attribute providers
 */
export const attributeProviderControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<AttributeProviderControllerGetAllData, ThrowOnError>): RequestResult<AttributeProviderControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AttributeProviderControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers',
    ...options
});

/**
 * Create a new attribute provider
 */
export const attributeProviderControllerCreate = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerCreateData, ThrowOnError>): RequestResult<AttributeProviderControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AttributeProviderControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an attribute provider
 */
export const attributeProviderControllerDelete = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerDeleteData, ThrowOnError>): RequestResult<AttributeProviderControllerDeleteResponses, AttributeProviderControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<AttributeProviderControllerDeleteResponses, AttributeProviderControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options
});

/**
 * Get an attribute provider by ID
 */
export const attributeProviderControllerGetById = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerGetByIdData, ThrowOnError>): RequestResult<AttributeProviderControllerGetByIdResponses, AttributeProviderControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<AttributeProviderControllerGetByIdResponses, AttributeProviderControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options
});

/**
 * Update an attribute provider
 */
export const attributeProviderControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerUpdateData, ThrowOnError>): RequestResult<AttributeProviderControllerUpdateResponses, AttributeProviderControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<AttributeProviderControllerUpdateResponses, AttributeProviderControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List credential configurations
 */
export const credentialConfigControllerGetConfigs = <ThrowOnError extends boolean = true>(options?: Options<CredentialConfigControllerGetConfigsData, ThrowOnError>): RequestResult<CredentialConfigControllerGetConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CredentialConfigControllerGetConfigsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials',
    ...options
});

/**
 * Create a credential configuration
 */
export const credentialConfigControllerStoreCredentialConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerStoreCredentialConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerStoreCredentialConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).post<CredentialConfigControllerStoreCredentialConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a credential configuration
 */
export const credentialConfigControllerDeleteIssuanceConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerDeleteIssuanceConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerDeleteIssuanceConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CredentialConfigControllerDeleteIssuanceConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options
});

/**
 * Get a credential configuration by ID
 */
export const credentialConfigControllerGetConfigById = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerGetConfigByIdData, ThrowOnError>): RequestResult<CredentialConfigControllerGetConfigByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<CredentialConfigControllerGetConfigByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options
});

/**
 * Update a credential configuration
 */
export const credentialConfigControllerUpdateCredentialConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerUpdateCredentialConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerUpdateCredentialConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<CredentialConfigControllerUpdateCredentialConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the presentation request configurations.
 */
export const presentationManagementControllerConfiguration = <ThrowOnError extends boolean = true>(options?: Options<PresentationManagementControllerConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerConfigurationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PresentationManagementControllerConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config',
    ...options
});

/**
 * Store a presentation request configuration. If it already exists, it will be updated.
 */
export const presentationManagementControllerStorePresentationConfig = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerStorePresentationConfigData, ThrowOnError>): RequestResult<PresentationManagementControllerStorePresentationConfigResponses, PresentationManagementControllerStorePresentationConfigErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerStorePresentationConfigResponses, PresentationManagementControllerStorePresentationConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve external issuer metadata
 *
 * Fetches OpenID4VCI credential issuer metadata from an external issuer URL on the server side.
 */
export const presentationManagementControllerResolveIssuerMetadata = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveIssuerMetadataData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveIssuerMetadataErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveIssuerMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/issuer-metadata/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve external schema metadata
 *
 * Fetches schema metadata from an external URL, extracts signedJwt, validates the JWT payload shape and returns normalized fields for presentation config import.
 */
export const presentationManagementControllerResolveSchemaMetadata = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveSchemaMetadataData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerResolveSchemaMetadataErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerResolveSchemaMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve schema metadata JWT
 *
 * Validates and resolves a signed schema metadata JWT directly, building DCQL and resolving schema references. Useful for resolving catalog entries without requiring external URL accessibility.
 */
export const presentationManagementControllerResolveSchemaMetadataJwt = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveSchemaMetadataJwtData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataJwtErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataJwtErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/resolve-jwt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List schema metadata from the registrar catalog
 *
 * Returns all schema metadata entries from the configured registrar. Returns an empty array when no registrar is configured.
 */
export const presentationManagementControllerListSchemaMetadataCatalog = <ThrowOnError extends boolean = true>(options?: Options<PresentationManagementControllerListSchemaMetadataCatalogData, ThrowOnError>): RequestResult<PresentationManagementControllerListSchemaMetadataCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PresentationManagementControllerListSchemaMetadataCatalogResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/catalog',
    ...options
});

/**
 * Deletes a presentation request configuration by its ID.
 */
export const presentationManagementControllerDeleteConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerDeleteConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerDeleteConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<PresentationManagementControllerDeleteConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options
});

/**
 * Get a presentation request configuration by its ID.
 */
export const presentationManagementControllerGetConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerGetConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerGetConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).get<PresentationManagementControllerGetConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options
});

/**
 * Update a presentation request configuration by its ID.
 */
export const presentationManagementControllerUpdateConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerUpdateConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerUpdateConfigurationResponses, PresentationManagementControllerUpdateConfigurationErrors, ThrowOnError> => (options.client ?? client).patch<PresentationManagementControllerUpdateConfigurationResponses, PresentationManagementControllerUpdateConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reissue the registration certificate cache
 *
 * Bypasses the embedded registration-certificate cache and resolves the certificate again: an imported JWT is checked again, `id` and `body` are resolved at the configured registrar.
 */
export const presentationManagementControllerReissueRegistrationCertificate = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerReissueRegistrationCertificateData, ThrowOnError>): RequestResult<PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerReissueRegistrationCertificateErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerReissueRegistrationCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}/registration-cert/reissue',
    ...options
});

/**
 * Returns all trust lists for the tenant
 */
export const trustListControllerGetAllTrustLists = <ThrowOnError extends boolean = true>(options?: Options<TrustListControllerGetAllTrustListsData, ThrowOnError>): RequestResult<TrustListControllerGetAllTrustListsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TrustListControllerGetAllTrustListsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list',
    ...options
});

/**
 * Creates a new trust list for the tenant
 */
export const trustListControllerCreateTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerCreateTrustListData, ThrowOnError>): RequestResult<TrustListControllerCreateTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).post<TrustListControllerCreateTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a trust list that no configuration of the tenant references
 */
export const trustListControllerDeleteTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerDeleteTrustListData, ThrowOnError>): RequestResult<TrustListControllerDeleteTrustListResponses, TrustListControllerDeleteTrustListErrors, ThrowOnError> => (options.client ?? client).delete<TrustListControllerDeleteTrustListResponses, TrustListControllerDeleteTrustListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options
});

/**
 * Returns the trust list by id for the tenant
 */
export const trustListControllerGetTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options
});

/**
 * Updates a trust list with new entities
 * Creates a new version for audit and regenerates the JWT
 */
export const trustListControllerUpdateTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerUpdateTrustListData, ThrowOnError>): RequestResult<TrustListControllerUpdateTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).put<TrustListControllerUpdateTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports the trust list in the format accepted by create and config import
 */
export const trustListControllerExportTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerExportTrustListData, ThrowOnError>): RequestResult<TrustListControllerExportTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerExportTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/export',
    ...options
});

/**
 * Returns the version history for a trust list
 */
export const trustListControllerGetTrustListVersions = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListVersionsData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListVersionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListVersionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/versions',
    ...options
});

/**
 * Returns a specific version of a trust list
 */
export const trustListControllerGetTrustListVersion = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListVersionData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListVersionResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/versions/{versionId}',
    ...options
});

/**
 * Get cache statistics
 *
 * Returns statistics about the trust list and status list caches.
 */
export const cacheControllerGetStats = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerGetStatsData, ThrowOnError>): RequestResult<CacheControllerGetStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CacheControllerGetStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/stats',
    ...options
});

/**
 * Clear all caches
 *
 * Clears the trust list, OpenID Federation trust and status list caches. Next verification will fetch fresh data.
 */
export const cacheControllerClearAllCaches = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearAllCachesData, ThrowOnError>): RequestResult<CacheControllerClearAllCachesResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearAllCachesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache',
    ...options
});

/**
 * Clear trust list cache
 *
 * Clears the trust list cache and the OpenID Federation trust cache. Next verification will fetch fresh trust lists and re-evaluate federation trust.
 */
export const cacheControllerClearTrustListCache = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearTrustListCacheData, ThrowOnError>): RequestResult<CacheControllerClearTrustListCacheResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearTrustListCacheResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/trust-list',
    ...options
});

/**
 * Clear status list cache
 *
 * Clears the status list (revocation) cache. Next status check will fetch fresh status lists.
 */
export const cacheControllerClearStatusListCache = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearStatusListCacheData, ThrowOnError>): RequestResult<CacheControllerClearStatusListCacheResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearStatusListCacheResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/status-list',
    ...options
});

/**
 * List the tenant's federation trust anchors
 */
export const federationTrustAnchorControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<FederationTrustAnchorControllerGetAllData, ThrowOnError>): RequestResult<FederationTrustAnchorControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FederationTrustAnchorControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/federation-trust-anchor',
    ...options
});

/**
 * Register a federation trust anchor
 */
export const federationTrustAnchorControllerCreate = <ThrowOnError extends boolean = true>(options: Options<FederationTrustAnchorControllerCreateData, ThrowOnError>): RequestResult<FederationTrustAnchorControllerCreateResponses, FederationTrustAnchorControllerCreateErrors, ThrowOnError> => (options.client ?? client).post<FederationTrustAnchorControllerCreateResponses, FederationTrustAnchorControllerCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/federation-trust-anchor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a federation trust anchor
 */
export const federationTrustAnchorControllerDelete = <ThrowOnError extends boolean = true>(options: Options<FederationTrustAnchorControllerDeleteData, ThrowOnError>): RequestResult<FederationTrustAnchorControllerDeleteResponses, FederationTrustAnchorControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<FederationTrustAnchorControllerDeleteResponses, FederationTrustAnchorControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/federation-trust-anchor/{id}',
    ...options
});

/**
 * Get a federation trust anchor by ID
 */
export const federationTrustAnchorControllerGetById = <ThrowOnError extends boolean = true>(options: Options<FederationTrustAnchorControllerGetByIdData, ThrowOnError>): RequestResult<FederationTrustAnchorControllerGetByIdResponses, FederationTrustAnchorControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<FederationTrustAnchorControllerGetByIdResponses, FederationTrustAnchorControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/federation-trust-anchor/{id}',
    ...options
});

/**
 * Update a federation trust anchor
 */
export const federationTrustAnchorControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<FederationTrustAnchorControllerUpdateData, ThrowOnError>): RequestResult<FederationTrustAnchorControllerUpdateResponses, FederationTrustAnchorControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<FederationTrustAnchorControllerUpdateResponses, FederationTrustAnchorControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/federation-trust-anchor/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get sessions (paginated)
 *
 * A client that reads sessions of a type through `sessions:read` but cannot cancel or delete them (that needs `issuance:offer` or `presentation:request`, and `issuance:offer` or `issuance:manage` for issuance sessions, `presentation:request` or `presentation:manage` for presentation sessions) does not get the sessions of that type that a wallet can still redeem or answer (open status, not consumed): they are left out of the list and answer 404, since their ID is enough to redeem or answer them.
 */
export const sessionControllerGetAllSessions = <ThrowOnError extends boolean = true>(options?: Options<SessionControllerGetAllSessionsData, ThrowOnError>): RequestResult<SessionControllerGetAllSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionControllerGetAllSessionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session',
    ...options
});

/**
 * Get session counts per type and status
 *
 * Counts all stored sessions of the tenant, not one page, optionally only those created in a time range. Only the session types the caller may read are included.
 */
export const sessionControllerGetSessionStats = <ThrowOnError extends boolean = true>(options?: Options<SessionControllerGetSessionStatsData, ThrowOnError>): RequestResult<SessionControllerGetSessionStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionControllerGetSessionStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/stats',
    ...options
});

/**
 * Deletes a session by its ID
 */
export const sessionControllerDeleteSession = <ThrowOnError extends boolean = true>(options: Options<SessionControllerDeleteSessionData, ThrowOnError>): RequestResult<SessionControllerDeleteSessionResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SessionControllerDeleteSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}',
    ...options
});

/**
 * Get a session
 *
 * A client that reads sessions of a type through `sessions:read` but cannot cancel or delete them (that needs `issuance:offer` or `presentation:request`, and `issuance:offer` or `issuance:manage` for issuance sessions, `presentation:request` or `presentation:manage` for presentation sessions) does not get the sessions of that type that a wallet can still redeem or answer (open status, not consumed): they are left out of the list and answer 404, since their ID is enough to redeem or answer them. It gets the other sessions of that type without `authorization_code`, `refresh_token`, `request_uri`, `auth_queries`, `offer`, `offerUrl`, `requestUrl`, `requestObject`, `responseEncryptionPrivateJwk`, `vp_nonce`, `walletNonce`, `responseUri`, `responseCode`, `credentialPayload.tx_code`.
 */
export const sessionControllerGetSession = <ThrowOnError extends boolean = true>(options: Options<SessionControllerGetSessionData, ThrowOnError>): RequestResult<SessionControllerGetSessionResponses, unknown, ThrowOnError> => (options.client ?? client).get<SessionControllerGetSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}',
    ...options
});

/**
 * Cancel a pending offer
 *
 * Cancels an issuance offer or presentation request that a wallet has not redeemed yet, so it can no longer be used to start a flow. The session is kept with the status `cancelled`. Once a wallet exchanged the offer for tokens or answered the request, the session can no longer be cancelled; to revoke credentials that were already issued, use `POST /session/revoke`.
 */
export const sessionControllerCancel = <ThrowOnError extends boolean = true>(options: Options<SessionControllerCancelData, ThrowOnError>): RequestResult<SessionControllerCancelResponses, SessionControllerCancelErrors, ThrowOnError> => (options.client ?? client).post<SessionControllerCancelResponses, SessionControllerCancelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get session log entries
 */
export const sessionControllerGetSessionLogs = <ThrowOnError extends boolean = true>(options: Options<SessionControllerGetSessionLogsData, ThrowOnError>): RequestResult<SessionControllerGetSessionLogsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SessionControllerGetSessionLogsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}/logs',
    ...options
});

/**
 * Get the status of the credentials issued in a session
 *
 * Lists one entry per issued credential that carries a status, with its current value in the status list and the list's bits per entry. The list is empty when no credential of the session carries a status. Change the status with `POST /session/revoke`.
 */
export const sessionControllerGetCredentialStatus = <ThrowOnError extends boolean = true>(options: Options<SessionControllerGetCredentialStatusData, ThrowOnError>): RequestResult<SessionControllerGetCredentialStatusResponses, SessionControllerGetCredentialStatusErrors, ThrowOnError> => (options.client ?? client).get<SessionControllerGetCredentialStatusResponses, SessionControllerGetCredentialStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}/credential-status',
    ...options
});

/**
 * Change the status of the credentials issued in a session
 *
 * Revokes (1), suspends (2) or reinstates (0) all credentials issued in the session, optionally only those of one credential configuration. Revocation is final.
 */
export const sessionControllerRevokeAll = <ThrowOnError extends boolean = true>(options: Options<SessionControllerRevokeAllData, ThrowOnError>): RequestResult<SessionControllerRevokeAllResponses, SessionControllerRevokeAllErrors, ThrowOnError> => (options.client ?? client).post<SessionControllerRevokeAllResponses, SessionControllerRevokeAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset session storage configuration
 *
 * Resets the session storage configuration to use global defaults.
 */
export const sessionConfigControllerResetConfig = <ThrowOnError extends boolean = true>(options?: Options<SessionConfigControllerResetConfigData, ThrowOnError>): RequestResult<SessionConfigControllerResetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<SessionConfigControllerResetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options
});

/**
 * Get session storage configuration
 *
 * Returns the session storage configuration for the current tenant.
 */
export const sessionConfigControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<SessionConfigControllerGetConfigData, ThrowOnError>): RequestResult<SessionConfigControllerGetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionConfigControllerGetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options
});

/**
 * Update session storage configuration
 *
 * Updates the session storage configuration for the current tenant.
 */
export const sessionConfigControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<SessionConfigControllerUpdateConfigData, ThrowOnError>): RequestResult<SessionConfigControllerUpdateConfigResponses, unknown, ThrowOnError> => (options.client ?? client).put<SessionConfigControllerUpdateConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe to session status updates
 *
 * Server-Sent Events endpoint for real-time session status updates. The first event carries the current status; the stream ends after a terminal status (completed, expired, failed). Authorized like GET /session/{id}: send the token in the Authorization header.
 */
export const sessionEventsControllerSubscribeToSessionEvents = <ThrowOnError extends boolean = true>(options: Options<SessionEventsControllerSubscribeToSessionEventsData, ThrowOnError, SessionEventsControllerSubscribeToSessionEventsResponse>): Promise<ServerSentEventsResult<SessionEventsControllerSubscribeToSessionEventsResponses>> => (options.client ?? client).sse.get<SessionEventsControllerSubscribeToSessionEventsResponses, SessionEventsControllerSubscribeToSessionEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}/events',
    ...options
});

/**
 * Reset status list configuration
 *
 * Reset the status list configuration to global defaults. Capacity and bits apply to status lists created afterwards; TTL, update mode and aggregation apply to all status lists of the tenant.
 */
export const statusListConfigControllerResetConfig = <ThrowOnError extends boolean = true>(options?: Options<StatusListConfigControllerResetConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerResetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<StatusListConfigControllerResetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options
});

/**
 * Get status list configuration
 *
 * Returns the current status list configuration for the tenant. Fields not set use global defaults.
 */
export const statusListConfigControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<StatusListConfigControllerGetConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerGetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusListConfigControllerGetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options
});

/**
 * Update status list configuration
 *
 * Update the status list configuration. Capacity and bits apply to status lists created afterwards; TTL, update mode and aggregation apply to all status lists of the tenant. Set a field to null to reset to global default.
 */
export const statusListConfigControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<StatusListConfigControllerUpdateConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerUpdateConfigResponses, unknown, ThrowOnError> => (options.client ?? client).put<StatusListConfigControllerUpdateConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all status lists
 *
 * Returns all status lists for the tenant, including their capacity and usage.
 */
export const statusListManagementControllerGetLists = <ThrowOnError extends boolean = true>(options?: Options<StatusListManagementControllerGetListsData, ThrowOnError>): RequestResult<StatusListManagementControllerGetListsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusListManagementControllerGetListsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists',
    ...options
});

/**
 * Create a status list
 *
 * Creates a new status list. Optionally bind it to a specific credential configuration and/or certificate.
 */
export const statusListManagementControllerCreateList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerCreateListData, ThrowOnError>): RequestResult<StatusListManagementControllerCreateListResponses, unknown, ThrowOnError> => (options.client ?? client).post<StatusListManagementControllerCreateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a status list
 *
 * Delete a status list. Only allowed if no credentials are using it.
 */
export const statusListManagementControllerDeleteList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerDeleteListData, ThrowOnError>): RequestResult<StatusListManagementControllerDeleteListResponses, unknown, ThrowOnError> => (options.client ?? client).delete<StatusListManagementControllerDeleteListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options
});

/**
 * Get a status list
 *
 * Returns details for a specific status list.
 */
export const statusListManagementControllerGetList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerGetListData, ThrowOnError>): RequestResult<StatusListManagementControllerGetListResponses, unknown, ThrowOnError> => (options.client ?? client).get<StatusListManagementControllerGetListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options
});

/**
 * Update a status list
 *
 * Update a status list's credential configuration binding and/or certificate.
 */
export const statusListManagementControllerUpdateList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerUpdateListData, ThrowOnError>): RequestResult<StatusListManagementControllerUpdateListResponses, unknown, ThrowOnError> => (options.client ?? client).patch<StatusListManagementControllerUpdateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all webhook endpoints for the tenant.
 */
export const webhookEndpointControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<WebhookEndpointControllerGetAllData, ThrowOnError>): RequestResult<WebhookEndpointControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WebhookEndpointControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints',
    ...options
});

/**
 * Create a new webhook endpoint
 */
export const webhookEndpointControllerCreate = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerCreateData, ThrowOnError>): RequestResult<WebhookEndpointControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<WebhookEndpointControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a webhook endpoint
 */
export const webhookEndpointControllerDelete = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerDeleteData, ThrowOnError>): RequestResult<WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options
});

/**
 * Get a webhook endpoint by ID
 */
export const webhookEndpointControllerGetById = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerGetByIdData, ThrowOnError>): RequestResult<WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options
});

/**
 * Update a webhook endpoint
 */
export const webhookEndpointControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerUpdateData, ThrowOnError>): RequestResult<WebhookEndpointControllerUpdateResponses, WebhookEndpointControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<WebhookEndpointControllerUpdateResponses, WebhookEndpointControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get issuance configuration
 */
export const issuanceConfigControllerGetIssuanceConfigurations = <ThrowOnError extends boolean = true>(options?: Options<IssuanceConfigControllerGetIssuanceConfigurationsData, ThrowOnError>): RequestResult<IssuanceConfigControllerGetIssuanceConfigurationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IssuanceConfigControllerGetIssuanceConfigurationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config',
    ...options
});

/**
 * Create or replace issuance configuration
 */
export const issuanceConfigControllerStoreIssuanceConfiguration = <ThrowOnError extends boolean = true>(options: Options<IssuanceConfigControllerStoreIssuanceConfigurationData, ThrowOnError>): RequestResult<IssuanceConfigControllerStoreIssuanceConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).post<IssuanceConfigControllerStoreIssuanceConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reissue issuer registration certificate
 *
 * Bypasses and refreshes the issuer registration certificate cache, revoking the previous active certificate when replaced.
 */
export const issuanceConfigControllerReissueRegistrationCertificate = <ThrowOnError extends boolean = true>(options?: Options<IssuanceConfigControllerReissueRegistrationCertificateData, ThrowOnError>): RequestResult<IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerReissueRegistrationCertificateErrors, ThrowOnError> => (options?.client ?? client).post<IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerReissueRegistrationCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config/registration-cert/reissue',
    ...options
});

/**
 * Publish TS11 schema metadata via registrar
 *
 * Builds multipart schema metadata input (metadata JSON + rulebook + schema files) and submits it to the registrar, which builds and signs the final schema metadata.
 */
export const schemaMetadataControllerPublishSchemaMetadata = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerPublishSchemaMetadataData, ThrowOnError>): RequestResult<SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataErrors, ThrowOnError> => (options.client ?? client).post<SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish a new version of an existing schema metadata entry
 *
 * Submits schema metadata input values for a new version under an existing schema ID. Registrar builds and signs the resulting schema metadata.
 */
export const schemaMetadataControllerPublishSchemaMetadataVersion = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerPublishSchemaMetadataVersionData, ThrowOnError>): RequestResult<SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, ThrowOnError> => (options.client ?? client).post<SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/publish-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get predefined schema metadata vocabularies
 */
export const schemaMetadataControllerGetVocabularies = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerGetVocabulariesData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetVocabulariesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerGetVocabulariesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/vocabularies',
    ...options
});

/**
 * List schema metadata
 */
export const schemaMetadataControllerFindAll = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerFindAllData, ThrowOnError>): RequestResult<SchemaMetadataControllerFindAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerFindAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata',
    ...options
});

/**
 * List schema metadata controlled by the user
 */
export const schemaMetadataControllerGetMine = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerGetMineData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetMineResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerGetMineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/mine',
    ...options
});

/**
 * Get schema metadata by ID
 */
export const schemaMetadataControllerFindOne = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerFindOneData, ThrowOnError>): RequestResult<SchemaMetadataControllerFindOneResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerFindOneResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}',
    ...options
});

/**
 * Delete schema metadata
 */
export const schemaMetadataControllerRemove = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerRemoveData, ThrowOnError>): RequestResult<SchemaMetadataControllerRemoveResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SchemaMetadataControllerRemoveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}',
    ...options
});

/**
 * Update schema metadata attributes
 */
export const schemaMetadataControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerUpdateData, ThrowOnError>): RequestResult<SchemaMetadataControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SchemaMetadataControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get latest version of schema metadata by ID
 */
export const schemaMetadataControllerGetLatest = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetLatestData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetLatestResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetLatestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/latest',
    ...options
});

/**
 * List all versions of a schema metadata entry
 */
export const schemaMetadataControllerGetVersions = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetVersionsData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetVersionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetVersionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions',
    ...options
});

/**
 * Get signed schema metadata JWT
 */
export const schemaMetadataControllerGetJwt = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetJwtData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetJwtResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetJwtResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/jwt',
    ...options
});

/**
 * Get schema content for a specific format
 */
export const schemaMetadataControllerGetSchema = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetSchemaData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetSchemaResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetSchemaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/schemas/{format}',
    ...options
});

/**
 * Deprecate a schema metadata version
 */
export const schemaMetadataControllerDeprecateVersion = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerDeprecateVersionData, ThrowOnError>): RequestResult<SchemaMetadataControllerDeprecateVersionResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SchemaMetadataControllerDeprecateVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/deprecation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an offer for a credential.
 */
export const credentialOfferControllerGetOffer = <ThrowOnError extends boolean = true>(options: Options<CredentialOfferControllerGetOfferData, ThrowOnError>): RequestResult<CredentialOfferControllerGetOfferResponses, unknown, ThrowOnError> => (options.client ?? client).post<CredentialOfferControllerGetOfferResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete a deferred credential transaction
 *
 * Completes a pending deferred credential transaction by providing the claims. The credential will be generated and marked as ready for wallet retrieval.
 */
export const deferredControllerCompleteDeferred = <ThrowOnError extends boolean = true>(options: Options<DeferredControllerCompleteDeferredData, ThrowOnError>): RequestResult<DeferredControllerCompleteDeferredResponses, DeferredControllerCompleteDeferredErrors, ThrowOnError> => (options.client ?? client).post<DeferredControllerCompleteDeferredResponses, DeferredControllerCompleteDeferredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/deferred/{transactionId}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fail a deferred credential transaction
 *
 * Marks a deferred credential transaction as failed. The wallet will receive an invalid_transaction_id error when attempting retrieval.
 */
export const deferredControllerFailDeferred = <ThrowOnError extends boolean = true>(options: Options<DeferredControllerFailDeferredData, ThrowOnError>): RequestResult<DeferredControllerFailDeferredResponses, DeferredControllerFailDeferredErrors, ThrowOnError> => (options.client ?? client).post<DeferredControllerFailDeferredResponses, DeferredControllerFailDeferredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/deferred/{transactionId}/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an presentation request that can be sent to the user
 */
export const verifierOfferControllerGetOffer = <ThrowOnError extends boolean = true>(options: Options<VerifierOfferControllerGetOfferData, ThrowOnError>): RequestResult<VerifierOfferControllerGetOfferResponses, unknown, ThrowOnError> => (options.client ?? client).post<VerifierOfferControllerGetOfferResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload files that belong to a tenant like images
 */
export const storageControllerUpload = <ThrowOnError extends boolean = true>(options: Options<StorageControllerUploadData, ThrowOnError>): RequestResult<StorageControllerUploadResponses, unknown, ThrowOnError> => (options.client ?? client).post<StorageControllerUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/storage',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Export the current tenant configuration
 */
export const configPortabilityControllerExport = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerExportData, ThrowOnError>): RequestResult<ConfigPortabilityControllerExportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/export',
    ...options
});

/**
 * Plan and validate a tenant configuration import
 */
export const configPortabilityControllerPlan = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerPlanData, ThrowOnError>): RequestResult<ConfigPortabilityControllerPlanResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerPlanResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/plan',
    ...options
});

/**
 * Plan an import from a configuration ZIP
 */
export const configPortabilityControllerPlanArchive = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerPlanArchiveData, ThrowOnError>): RequestResult<ConfigPortabilityControllerPlanArchiveResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerPlanArchiveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/plan/archive',
    ...options
});

/**
 * Apply a validated tenant configuration bundle
 */
export const configPortabilityControllerImport = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerImportData, ThrowOnError>): RequestResult<ConfigPortabilityControllerImportResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerImportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/import',
    ...options
});

/**
 * Apply a configuration ZIP
 */
export const configPortabilityControllerImportArchive = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerImportArchiveData, ThrowOnError>): RequestResult<ConfigPortabilityControllerImportArchiveResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerImportArchiveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/import/archive',
    ...options
});

/**
 * List recent configuration operations
 */
export const configPortabilityControllerOperations = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerOperationsData, ThrowOnError>): RequestResult<ConfigPortabilityControllerOperationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerOperationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations',
    ...options
});

/**
 * Read a durable configuration operation report
 */
export const configPortabilityControllerOperation = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerOperationData, ThrowOnError>): RequestResult<ConfigPortabilityControllerOperationResponses, unknown, ThrowOnError> => (options.client ?? client).get<ConfigPortabilityControllerOperationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations/{id}',
    ...options
});

/**
 * Release an interrupted operation after its worker has been stopped
 */
export const configPortabilityControllerAcknowledgeInterruption = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerAcknowledgeInterruptionData, ThrowOnError>): RequestResult<ConfigPortabilityControllerAcknowledgeInterruptionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerAcknowledgeInterruptionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations/{id}/acknowledge-interruption',
    ...options
});

/**
 * Upgrade one configuration document
 */
export const configPortabilityControllerUpgrade = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerUpgradeData, ThrowOnError>): RequestResult<ConfigPortabilityControllerUpgradeResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerUpgradeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/documents/upgrade',
    ...options
});

/**
 * List configuration resource ownership
 */
export const configPortabilityControllerResources = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerResourcesData, ThrowOnError>): RequestResult<ConfigPortabilityControllerResourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerResourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources',
    ...options
});

/**
 * List the configuration ownership of one resource kind
 *
 * Lets screens lock file-managed resources before a change fails with 409. Besides `tenant:admin` and `tenants:manage`, it accepts the roles that change the kind through the management API, for example `issuance:manage` for `CredentialConfig` or `presentation:manage` for `PresentationConfig`.
 */
export const configPortabilityControllerResourcesOfKind = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerResourcesOfKindData, ThrowOnError>): RequestResult<ConfigPortabilityControllerResourcesOfKindResponses, ConfigPortabilityControllerResourcesOfKindErrors, ThrowOnError> => (options.client ?? client).get<ConfigPortabilityControllerResourcesOfKindResponses, ConfigPortabilityControllerResourcesOfKindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}',
    ...options
});

/**
 * Export one resource as a configuration document
 *
 * Returns the resource as a `$schema` and `spec` document in the current format version, the format of the files in the config folder and of the documents in a configuration bundle. Secrets are `${PLACEHOLDER}` references, as in the bundle export, and image references name the file. A key chain held in the database keeps its private keys, for a CA chain also the signing key, which `GET /key-chain/{id}/export` leaves out, so a `KeyChain` document needs `tenant:admin` or `tenants:manage`. Other kinds accept the roles that change them through the management API, for example `issuance:manage` for `CredentialConfig` and `keys:manage` for `KeyChainDefaults`. Singleton kinds use their fixed ID: `tenant`, `kms`, `registrar`, `issuance` and `defaults`.
 */
export const configPortabilityControllerExportDocument = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerExportDocumentData, ThrowOnError>): RequestResult<ConfigPortabilityControllerExportDocumentResponses, ConfigPortabilityControllerExportDocumentErrors, ThrowOnError> => (options.client ?? client).get<ConfigPortabilityControllerExportDocumentResponses, ConfigPortabilityControllerExportDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}/{id}/document',
    ...options
});

/**
 * Detach a resource from file provisioning
 */
export const configPortabilityControllerDetach = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerDetachData, ThrowOnError>): RequestResult<ConfigPortabilityControllerDetachResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerDetachResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}/{id}/detach',
    ...options
});

/**
 * Plan resetting a resource to its version in the config folder
 */
export const configPortabilityControllerPlanReattach = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerPlanReattachData, ThrowOnError>): RequestResult<ConfigPortabilityControllerPlanReattachResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerPlanReattachResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}/{id}/reattach/plan',
    ...options
});

/**
 * Reset a resource to its version in the config folder and make it file-managed again
 */
export const configPortabilityControllerReattach = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerReattachData, ThrowOnError>): RequestResult<ConfigPortabilityControllerReattachResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerReattachResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}/{id}/reattach',
    ...options
});
